
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
  import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue'
  import {
    mallmallProductDetailInfo,
    mallmallProductDetailInfoSave
  } from "@/api/auth"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      'slz-dialog': Dialog,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private pageloading = false
    private form:any = {
      IsOpenLifeHouse:true,
      ProductDetailShareCardList:[
        {
          Id:1,
          IsChcek:false,
          Content:'的肉团生活馆分享的好物'
        },{
          Id:2,
          IsChcek:false,
          Content:'的肉团生活馆分享的好物'
        },{
          Id:3,
          IsChcek:false,
          Content:'的肉团生活馆分享的好物'
        },{
          Id:4,
          IsChcek:false,
          Content:'的肉团生活馆分享的好物'
        },
      ]
    }
    private changeShow = false
    private rowmsg:any = {}
    private useShow = false

    private mounted () {
      this.getinfo()
    }



    private confirm(){
      if(!this.rowmsg.Content){
        this.$message.error('请输入分享文案')
        return 
      }
      this.form.ProductDetailShareCardList = this.form.ProductDetailShareCardList.map(v=>{
        if(v.Id==this.rowmsg.Id){
          v = this.rowmsg
        }
        return v
      })
      this.changeShow = false
    }
    private edit(e){
      this.rowmsg = JSON.parse(JSON.stringify(e))
      this.changeShow = true
    }
    private changeUse(e){
      this.rowmsg = e
      this.useShow = true
    }
    private useMode(e){
      this.form.ProductDetailShareCardList = this.form.ProductDetailShareCardList.map((v,i)=>{
        v.IsChcek = false
        if(v.Id==this.rowmsg.Id){
          v.IsChcek = true
        }
        return v
      })
    }
    private async getinfo(){
      try{
        this.pageloading = true
        let res = await mallmallProductDetailInfo({})
        if(res.IsSuccess){
          let form = res.Result
          if(!form.ProductDetailShareCardList||!form.ProductDetailShareCardList.length){
            form.ProductDetailShareCardList = this.form.ProductDetailShareCardList
          }
          this.form = form
        }
      }finally{
        this.pageloading = false
      }
    }
    private async submit(){
      try{
        this.pageloading = true
        let res = await mallmallProductDetailInfoSave(this.form)
        if(res.IsSuccess){
          this.$message.success('保存成功')
        }
      }finally{
        this.pageloading = false
      }
    }
  }
